module.exports = __webpack_public_path__ + "media/components/Influencers/Shared/SocialNetworkIcon/twitter-b4bff0a471e795d9d49dfc722dad96b1.png";